import { useEffect, useState } from 'react'
import { api } from '../lib/api.js'

function Stat({ label, value, hint }) {
  return (
    <div className="card stat">
      <div className="stat-label">{label}</div>
      <div className="stat-value">{value ?? '-'}</div>
      {hint && <div className="stat-hint">{hint}</div>}
    </div>
  )
}

function Sparkline({ points }) {
  if (!points?.length) return null
  const max = Math.max(1, ...points.map((p) => p.count))
  return (
    <div className="spark">
      {points.map((p) => (
        <div
          key={p.day}
          className="spark-bar"
          style={{ height: `${(p.count / max) * 100}%` }}
          title={`${p.day.slice(0, 10)}: ${p.count}`}
        />
      ))}
    </div>
  )
}

export function Dashboard() {
  const [stats, setStats] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    api('/admin/stats')
      .then((r) => setStats(r.data))
      .catch((e) => setError(e.message))
  }, [])

  if (error) return <div className="alert">{error}</div>
  if (!stats) return <div className="muted">Yukleniyor...</div>

  return (
    <>
      <h1>Panel</h1>
      <div className="grid">
        <Stat label="Aktif kullanici" value={stats.active_users} hint={`son 7 gun: +${stats.new_users_7d}`} />
        <Stat label="Cocuk" value={stats.children} />
        <Stat
          label="Olcum"
          value={stats.measurements}
          hint={`son 7 gun: +${stats.measurements_7d}`}
        />
        <Stat
          label="WHO standart satiri"
          value={stats.growth_standard_rows}
          hint={stats.growth_standard_rows === 0 ? 'Veri yuklenmemis!' : 'yuklu'}
        />
      </div>

      <div className="card">
        <h2>Son 30 gun kayitlar</h2>
        <Sparkline points={stats.signup_trend} />
      </div>
    </>
  )
}
